import { render } from "./SetRegistryConfigurationDialog.vue?vue&type=template&id=316d8245&scoped=true&ts=true"
import script from "./SetRegistryConfigurationDialog.vue?vue&type=script&lang=ts"
export * from "./SetRegistryConfigurationDialog.vue?vue&type=script&lang=ts"

import "./SetRegistryConfigurationDialog.vue?vue&type=style&index=0&id=316d8245&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316d8245"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QSeparator,QBtn,QInput,QField});
